import React from "react";
import { useIntl } from "react-intl";
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import { Badge } from "primereact/badge";
import dayjs from "dayjs";

const MyRewards = ({ rewards, requesting }) => {
  const intl = useIntl();

  if (requesting) {
    return (
      <div className="flex justify-content-center p-4">
        <ProgressSpinner />
      </div>
    );
  }

  if (!rewards || rewards.length === 0) {
    return (
      <div className="text-center p-4">
        <i
          className="pi pi-star"
          style={{ fontSize: "3rem", color: "#ccc" }}
        ></i>
        <h3>{intl.formatMessage({ id: "no_rewards_earned" })}</h3>
      </div>
    );
  }

  const formatDate = (dateString) => {
    return dayjs(dateString).format("DD MMM, YYYY");
  };

  const getImageUrl = (artifactUrl) => {
    if (!artifactUrl) return null;
    return new URL(artifactUrl, process.env.REACT_APP_URL).toString();
  };

  return (
    <div className="rewards-grid">
      {rewards.map((reward) => (
        <Card
          key={reward.id}
          className="reward-card"
          header={
            reward.artifactUrl ? (
              <div className="reward-image-container">
                <img
                  src={getImageUrl(reward.artifactUrl)}
                  alt={reward.rewardName}
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.parentNode.innerHTML =
                      '<div class="reward-placeholder"><i class="pi pi-gift" style="font-size: 3rem; color: #ccc;"></i></div>';
                  }}
                />
              </div>
            ) : (
              <div className="reward-image-container">
                <div className="reward-placeholder">
                  <i
                    className="pi pi-gift"
                    style={{ fontSize: "3rem", color: "#ccc" }}
                  ></i>
                </div>
              </div>
            )
          }
        >
          <div className="reward-content">
            <h4>{reward.rewardName}</h4>
            {reward.rewardDescription && <p>{reward.rewardDescription}</p>}

            <div className="reward-details">
              <div className="reward-info">
                <strong>{intl.formatMessage({ id: "earned_from" })}:</strong>{" "}
                {reward.entityName}
              </div>

              {reward.pointsAwarded && (
                <Badge
                  value={`${reward.pointsAwarded} ${intl.formatMessage({
                    id: "points",
                  })}`}
                  severity="success"
                />
              )}

              <div className="reward-date">
                <strong>{intl.formatMessage({ id: "awarded_on" })}:</strong>{" "}
                {formatDate(reward.awardedAt)}
              </div>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default MyRewards;
